module.exports = __webpack_public_path__ + "img/link-icon.e49e495d.svg";